import * as E from 'fp-ts/lib/Either'

export interface SentryConfig {
  dsn: string
  enabled: boolean
}

const sitoDomains = ['espoositoavustukset.fi', 'espooavustukset.fi']
const staging = 'staging'
const test = 'test'
const dev = 'dev'

export type Environment =
  | 'local'
  | typeof dev
  | typeof test
  | typeof staging
  | 'prod'

export function getEnvironment(): E.Either<string, Environment> {
  if (window.location.host.startsWith('localhost')) {
    return E.right('local')
  }

  if (sitoDomains.indexOf(window.location.host) > -1) {
    return E.right('prod')
  }

  for (const sitoDomain of sitoDomains) {
    if (window.location.host === `${staging}.${sitoDomain}`) {
      return E.right(staging)
    }

    if (window.location.host === `${test}.${sitoDomain}`) {
      return E.right(test)
    }

    if (window.location.host === `${dev}.${sitoDomain}`) {
      return E.right(dev)
    }
  }

  return E.left(window.location.host)
}
